import { getLogActivityDecorator, LoggerFactory } from '@metaos/mfs-telemetry';
export const logger = LoggerFactory.getInstance().getMfsLogger('local-store');
/** A single logging decorator that works for both sync & async functions */
export const logActivity = getLogActivityDecorator(logger);
//# sourceMappingURL=logger.js.map